export enum VerificationActionTypes {
  getVerifyLink = 'getVerifyLink',
  verify = 'verify',
  verifyLinkFailure = 'verifyLinkFailure',
  sendSMSLink = 'sendSMSLink',
  manualFailure = 'manualFailure',
}
